module.exports = __webpack_public_path__ + "static/images/monet/alert_route_not_loaded.png";